import React, { useEffect } from "react";
import { useAuthUser } from "../../store/AuthUserContextProvider";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { isAuthenticated } from "../../utils";

const withAuthRequired = (ProtectedComponent) => {
  return (props) => {
    const history = useHistory();
    const routeLocation = useLocation();
    const { authUser } = useAuthUser();

    useEffect(() => {
      if (!isAuthenticated()) {
        localStorage.clear();
        history.push("/login");
      }
    });

    useEffect(() => {
      if (authUser.Role === "ref-doctor") {
        props.history.replace({ pathname: "/ref-doctor-worklist" });
      }
    }, [routeLocation.pathname]);

    return <ProtectedComponent {...props} />;
  };
};

export default withAuthRequired;
